import { useState, useEffect, ReactNode, useCallback } from 'react'
import { LanguageContext, type Language } from './LanguageContextDefinition'

interface LanguageProviderProps {
  children: ReactNode
}

export function LanguageProvider({ children }: LanguageProviderProps) {
  // Initialize language from localStorage or default to 'en'
  const [language, setLanguageState] = useState<Language>(() => {
    const savedLanguage = localStorage.getItem('language')
    return (savedLanguage as Language) || 'ja'
  })

  // Save language to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('language', language)
  }, [language])

  const toggleLanguage = useCallback(() => {
    setLanguageState((prev) => (prev === 'en' ? 'ja' : 'en'))
  }, [])

  const setLanguage = useCallback((lang: Language) => {
    setLanguageState(lang)
  }, [])

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}
